export const comments_5089929 = {"data":{"data":[],"links":{}}}